import React from 'react';

const Footer: React.FC = () => {
  console.log('Footer component rendered - comprehensive site navigation and links');

  return (
    <footer className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand Column */}
          <div className="col-span-1 lg:col-span-1">
            <div className="flex items-center space-x-2 mb-6">
              <div className="text-2xl font-bold text-blue-400">
                LessonLynx
              </div>
            </div>
            <p className="text-gray-300 text-sm leading-relaxed mb-6">
              Connecting passionate music teachers with eager students. 
              Focus on teaching, we handle the rest.
            </p>
            
            {/* Social Media Icons - Hidden for now */}
            {/* <div className="flex space-x-4">
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <span className="sr-only">Facebook</span>
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" />
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <span className="sr-only">LinkedIn</span>
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path fillRule="evenodd" d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <span className="sr-only">Instagram</span>
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path fillRule="evenodd" d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 6.62 5.367 11.987 11.988 11.987s11.987-5.367 11.987-11.987C24.014 5.367 18.647.001 12.017.001zM8.449 16.988c-1.297 0-2.448-.49-3.328-1.291L6.99 14.102c.48.525 1.169.854 1.938.854 1.423 0 2.575-1.134 2.575-2.532 0-1.398-1.152-2.532-2.575-2.532-.769 0-1.458.329-1.938.854L5.121 9.151c.88-.801 2.031-1.291 3.328-1.291 2.704 0 4.898 2.176 4.898 4.862s-2.194 4.862-4.898 4.862z"/>
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <span className="sr-only">TikTok</span>
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-5.2 1.74 2.89 2.89 0 012.31-4.64 2.93 2.93 0 01.88.13V9.4a6.84 6.84 0 00-.88-.05A6.33 6.33 0 005 20.1a6.34 6.34 0 0010.86-4.43v-7a8.16 8.16 0 004.77 1.52v-3.4a4.85 4.85 0 01-1-.1z"/>
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors">
                <span className="sr-only">YouTube</span>
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
                  <path fillRule="evenodd" d="M19.812 5.418c.861.23 1.538.907 1.768 1.768C21.998 8.746 22 12 22 12s0 3.255-.418 4.814a2.504 2.504 0 0 1-1.768 1.768c-1.56.419-7.814.419-7.814.419s-6.255 0-7.814-.419a2.505 2.505 0 0 1-1.768-1.768C2 15.255 2 12 2 12s0-3.255.417-4.814a2.507 2.507 0 0 1 1.768-1.768C5.744 5 11.998 5 11.998 5s6.255 0 7.814.418ZM15.194 12 10 15V9l5.194 3Z" clipRule="evenodd" />
                </svg>
              </a>
            </div> */}
          </div>

          {/* For Students Column */}
          <div>
            <h3 className="text-green-400 font-semibold text-sm uppercase tracking-wide mb-4">
              For Students
            </h3>
            <ul className="space-y-3">
              <li>
                <a href="/instrument-selection" className="text-gray-300 hover:text-white text-sm transition-colors">
                  Find a Teacher
                </a>
              </li>
              <li>
                <a href="/browse-teachers" className="text-gray-300 hover:text-white text-sm transition-colors">
                  Browse Teachers
                </a>
              </li>
              <li>
                <a href="/student-dashboard" className="text-gray-300 hover:text-white text-sm transition-colors">
                  Student Dashboard
                </a>
              </li>
              <li>
                <a href="/pricing" className="text-gray-300 hover:text-white text-sm transition-colors">
                  Pricing
                </a>
              </li>
            </ul>
          </div>

          {/* For Teachers Column */}
          <div>
            <h3 className="text-yellow-400 font-semibold text-sm uppercase tracking-wide mb-4">
              For Teachers
            </h3>
            <ul className="space-y-3">
              <li>
                <a href="/become-a-teacher" className="text-gray-300 hover:text-white text-sm transition-colors">
                  Teach with LessonLynx
                </a>
              </li>
              <li>
                <a href="/for-teachers" className="text-gray-300 hover:text-white text-sm transition-colors">
                  Commission Structure
                </a>
              </li>
              <li>
                <a href="/teacher-dashboard" className="text-gray-300 hover:text-white text-sm transition-colors">
                  Teacher Dashboard
                </a>
              </li>
              <li>
                <a href="/for-teachers" className="text-gray-300 hover:text-white text-sm transition-colors">
                  Teacher Benefits
                </a>
              </li>
            </ul>
          </div>

          {/* Support Column */}
          <div>
            <h3 className="text-blue-400 font-semibold text-sm uppercase tracking-wide mb-4">
              Support & Legal
            </h3>
            <ul className="space-y-3">
              <li>
                <a href="/help" className="text-gray-300 hover:text-white text-sm transition-colors">
                  Help Center
                </a>
              </li>
              <li>
                <a href="/contact" className="text-gray-300 hover:text-white text-sm transition-colors">
                  Contact Us
                </a>
              </li>
              <li>
                <a href="/about-us" className="text-gray-300 hover:text-white text-sm transition-colors">
                  About Us
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="mt-12 pt-8 border-t border-gray-700">
          <div className="flex flex-col lg:flex-row justify-between items-center space-y-4 lg:space-y-0">
            <div className="flex flex-col sm:flex-row items-center space-y-2 sm:space-y-0 sm:space-x-6">
              <p className="text-gray-400 text-sm">
                © {new Date().getFullYear()} LessonLynx. All Rights Reserved.
              </p>
              <div className="flex items-center space-x-4">
                <a href="/login" className="text-gray-400 hover:text-white text-sm transition-colors flex items-center">
                  Sign In
                  <svg className="ml-1 w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 